import React from "react";
import classNames from "classnames";
import { useClasses } from "../";
import { Blurhash } from "react-blurhash";
const styles = (theme) => ({});
const Image = (props) => {
    const classes = useClasses(styles, props);
    const { override } = props;
    return (React.createElement("div", { className: classNames([classes.img, override === null || override === void 0 ? void 0 : override.wrapper]) },
        React.createElement(Blurhash, { hash: props.hash, width: 400, height: 300, resolutionX: 32, resolutionY: 32, punch: 1 })));
};
export default Image;
